import template from './tsz-notification-badge.html';
import './tsz-notification-badge.styl';

export default {
  template,
  bindings: {
    total: '<',
    hideWhenOk: '<',
  },
};



// WEBPACK FOOTER //
// ./src/components/tsz-notification-badge/tsz-notification-badge.js